module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_1-3dc22ec106a8d5cc441745f1d1a0d91a.webp";